import React, { type ComponentType } from 'react';
import { ThemeProvider } from 'styled-components';

import { theme, DesignSystemGlobals } from '@kueski-dev/kueski-design-system';

type withDesignSystemHoC = <P extends object>(
  Component: ComponentType<P>
) => (props: P) => React.JSX.Element

export const withDesignSystem: withDesignSystemHoC = Component => props => (
  <ThemeProvider theme={theme}>
    <DesignSystemGlobals />
    <Component {...props} />
  </ThemeProvider>
);
